import React, { useState, useRef, useContext, useEffect, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Navigate } from 'react-router-dom';
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallback";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import { Chart } from "react-google-charts";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Chip from "@mui/material/Chip";
import TextInput from "components/Input/TextInput.js";
import TextInputWithChip from "components/Input/TextInputWithChip";
import { indexOf, update } from "lodash";
import { getIndicators, getDictionnary, getChartpoints } from "services/ConfigServices";
import UserService from "services/UserService";
import styled from "styled-components";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import Dialog from "@mui/material/Dialog";
import AdvancedDefDialogIndic from "components/RTCharts/AdvancedDefDialogIndic";
import AdvancedDefDialogPoint from "components/RTCharts/AdvancedDefDialogPoint";
import {withStyles} from "@mui/styles";
import { realestatedata } from "variables/lists/charts";
import AdvancedDefDialogRealestate from "components/RTCharts/AdvancedDefDialogRealestate";
import AddValueToFormula from "components/RTCharts/AddValueToFormula";
import { dico } from "variables/lists/dico";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const useStyles2 = makeStyles((theme) => ({
  indicatorchip: {
    maxWidth: "150px",
    cursor: "pointer",
  },
}));

const FormulaDiv = styled.div`
min-height: 100px;
background: white;
border: solid;
border-width: 1px;
border-color: grey;
padding: 6px;
`;

const FormulaText = styled.span`
  font-size: 17px;
  opacity: 1;
  margin: 5px;
  vertical-align: middle;
  letter-spacing: 4px!important;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function TestPage() {
  const appContext = useContext(AdvancedSearchContext);
  const [open, setOpen] = useState(false);
  const [openpoint, setOpenpoint] = useState(false);
  const [openrealestate, setOpenrealestatet] = useState(false);
  const [openaddindic, setOpenaddindic] = useState(false);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [redirState, setRedirState] = useState(false);

  const [formula, setFormula] = useState("");
  const [formulapretty, setFormulapretty] = useState([]);
  const [indicatordata, setIndicatordata] = useState([]);
  const [pointdata, setPointdata] = useState([]);
  const [avalaibleDico, setAvailableDico] = useState([]);
  const [currentdef, setCurrentdef] = useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };
  const handleClickOpenpoint = () => {
    setOpenpoint(true);
  };
  const handleEditClosepoint = () => {
    setOpenpoint(false);
  };
  const handleClickOpenrealestate = () => {
    setOpenrealestatet(true);
  };
  const handleEditCloserealestate = () => {
    setOpenrealestatet(false);
  };
  const handleClickOpenaddindic = () => {
    setOpenaddindic(true);
  };
  const handleEditCloseaddindic = () => {
    setOpenaddindic(false);
  };
  const handleFormulaChange = (event) => {
    setFormula(event.target.value);
  };
  const handleFormulaprettyChange = (event) => {
    setFormulapretty(event.target.value);
  };

  useEffect(() => {
    axios
      .get(
        getIndicators(chartIdGroup, "charts", ""),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setIndicatordata(res.data.indicators || []);
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    axios
      .get(
        getChartpoints(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPointdata(res.data.points || []);
        let tmpdefinitiondata = dico.filter((item) =>
          res.data.points.find((x) => x.definition == item.id)
        );
        setAvailableDico(tmpdefinitiondata);

      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    let formulatmp = formula;
    let formulaprettytmp = [];
    let updateformulapretty = true;
    let currentindex = 0;
    let formulaprettyobjectindex = 0;
    while (formulatmp) {
      console.log(formulatmp);
      currentindex = 0;
      if (formulatmp.includes("{")) {
        let stringendindex = formulatmp.indexOf("{");
        if (stringendindex > currentindex) {
          formulaprettytmp.push(formulatmp.substring(currentindex, stringendindex));
        }
        formulatmp = formulatmp.substring(formulatmp.indexOf("{"));
        if (formulatmp.startsWith("{I,")) {
          if (formulatmp.includes("}")) {
            let fullindicdef = formulatmp.substring(formulatmp.indexOf("{I,"), formulatmp.indexOf("}") + 1);
            let indicdef = formulatmp.substring(formulatmp.indexOf("{I,") + 3, formulatmp.indexOf("}")).split(",");
            let indicid;
            let agregatg = 'SUM';
            let replacebyzero = false;
            let decalage;
            let filter;
            if (indicdef.length > 0) {
              indicid = indicdef[0];
              if (indicdef.length > 1) {
                agregatg = indicdef[1];
                if (indicdef.length > 2) {
                  replacebyzero = indicdef[2];
                  if (indicdef.length > 3) {
                    decalage = indicdef[3];
                    if (indicdef.length > 3) {
                      filter = indicdef[4];
                    }
                  }
                }
              }
            }
            let indicname = indicatordata?.find((indic) => indic.id == indicid)?.name || "Inconnu";
            let granularity = indicatordata?.find((indic) => indic.id == indicid)?.timeresolution || "";


            currentindex = formulatmp.indexOf("}") + 1;
            formulaprettytmp.push({ type: 'indic', id: formulaprettyobjectindex, name: indicname, indicid, agregatg, replacebyzero, decalage, filter, granularity });
            formulaprettyobjectindex++;
            formulatmp = formulatmp.substring(formulatmp.indexOf("}") + 1);
          }
          else {
            updateformulapretty = false;
            break;
          }
        }
        else if (formulatmp.startsWith("{P,")) {
          if (formulatmp.includes("}")) {
            let fullpointdef = formulatmp.substring(formulatmp.indexOf("{P,"), formulatmp.indexOf("}") + 1);
            let pointdef = formulatmp.substring(formulatmp.indexOf("{P,") + 3, formulatmp.indexOf("}")).split(",");
            let pointid;
            let agregatg = 'SUM';
            let replacebyzero = false;
            let decalage;
            let filter;
            let granularity = 'auto';
            if (pointdef.length > 0) {
              pointid = pointdef[0];
              if (pointdef.length > 1) {
                granularity = pointdef[1];
                if (pointdef.length > 2) {
                  agregatg = pointdef[2];
                  if (pointdef.length > 3) {
                    replacebyzero = pointdef[3];
                    if (pointdef.length > 4) {
                      decalage = pointdef[4];
                      if (pointdef.length > 5) {
                        filter = pointdef[5];
                      }
                    }
                  }
                }
              }
            }
            let pointname = pointdata?.find((point) => point.pointid == pointid)?.name || "Inconnu";

            currentindex = formulatmp.indexOf("}") + 1;
            formulaprettytmp.push({ type: 'point', id: formulaprettyobjectindex, name: pointname, pointid, agregatg, replacebyzero, decalage, filter, granularity });
            formulaprettyobjectindex++;
            formulatmp = formulatmp.substring(formulatmp.indexOf("}") + 1);
          }
          else {
            updateformulapretty = false;
            break;
          }
        }
        else if (formulatmp.startsWith("{R,")) {
          if (formulatmp.includes("}")) {
            let pointdef = formulatmp.substring(formulatmp.indexOf("{R,") + 3, formulatmp.indexOf("}")).split(",");
            let pointid;
            let agregatv = 'SUM';
            let replacebyzero = false;
            if (pointdef.length > 0) {
              pointid = pointdef[0];
              if (pointdef.length > 1) {
                agregatv = pointdef[1];
                if (pointdef.length > 2) {
                  replacebyzero = pointdef[2];
                }
              }
            }
            let pointname = realestatedata?.find((point) => point.id == pointid)?.name || "Inconnu";

            currentindex = formulatmp.indexOf("}") + 1;
            formulaprettytmp.push({ type: 'realestate', id: formulaprettyobjectindex, name: pointname, pointid, agregatv, replacebyzero });
            formulaprettyobjectindex++;
            formulatmp = formulatmp.substring(formulatmp.indexOf("}") + 1);
          }
          else {
            updateformulapretty = false;
            break;
          }
        }
        else {
          updateformulapretty = false;
          break;
        }
      }
      else {
        formulaprettytmp.push(formulatmp);
        formulatmp = "";
      }
    }
    if (updateformulapretty)
      setFormulapretty(formulaprettytmp);

  }, [formula]);

  const parseFormula = (formula) => {

  }

  const formulaprettyEdited = (newformulapretty) => {
    console.log(newformulapretty);
    let formulatmp = "";
    newformulapretty.forEach((items) => {
      if (typeof items === 'object') {
        if (items.type === 'indic') {
          let text = "{I," + items.indicid + "," + items.agregatg + "," + items.replacebyzero;
          if (items.decalage)
            text += "," + items.decalage;
          if (items.filter)
            text += "," + items.filter;
          text += "}";
          formulatmp += text;
        }
        else if (items.type === 'point') {
          let text = "{P," + items.pointid + "," + items.granularity + "," + items.agregatg + "," + items.replacebyzero;
          if (items.decalage)
            text += "," + items.decalage;
          if (items.filter)
            text += "," + items.filter;
          text += "}";
          formulatmp += text;
        }
        else if (items.type === 'realestate') {
          let text = "{R," + items.pointid + "," + items.agregatv + "," + items.replacebyzero;
          text += "}";
          formulatmp += text;
        }
      }
      else
        formulatmp += items;
    });
    setFormula(formulatmp);
  }

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/testpage",
      }}
    />
  );

  const editDef = (index) => {
    let obj = formulapretty[index];
    if (obj) {
      setCurrentdef(obj);
      if (obj.type === 'indic')
        handleClickOpen();
      else if (obj.type === 'point')
        handleClickOpenpoint();
      else if (obj.type === 'realestate')
        handleClickOpenrealestate();
    }
  }

  const classes = useStyles2();
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"testpage"}
    >
      <GridContainer>
        <GridItem xs={10}>
          <TextInput
            inputTitle={"Formule"}
            textInput={formula}
            handleTextInputChange={handleFormulaChange}
            multiline
            rows={4}
          />
        </GridItem>

        <GridItem xs={2}>
          <UploadButton type="button">
            <AddValueToFormula
              formula={formula}
              setFormula={setFormula}
              indicatordata={indicatordata}
              pointdata={pointdata}
              realestatedata={realestatedata}
              avalaibleDico={avalaibleDico}
            />
          </UploadButton>
        </GridItem>
        <GridItem xs={12}>
          {/* <TextInputWithChip
            inputTitle={"Formule pretty"}
            textInput={formulapretty}
            handleTextInputChange={handleFormulaprettyChange}
            multiline
            rows={4}
          /> */}
          {/* <div style={{ height: 100 }}>
            <Chip variant="outlined" label={"Meteo"} />*<Chip variant="outlined" label={"Index conso"} />
          </div> */}
          <FormulaDiv>
            {
              formulapretty.map((items, index) => {
                if (typeof items === 'object') {
                  return <Tooltip title={items.name}><Chip variant="outlined" label={items.name} className={classes.indicatorchip} onClick={() => editDef(index)} /></Tooltip>
                }
                else
                  return <FormulaText>{items}</FormulaText>;
              })
            }

          </FormulaDiv>
        </GridItem>

      </GridContainer>
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          {"Paramètres de l'indicateur " + currentdef.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AdvancedDefDialogIndic
            closeModal={handleEditClose}
            def={currentdef}
            formulapretty={formulapretty}
            formulaprettyEdited={formulaprettyEdited}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditClosepoint}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openpoint}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClosepoint}>
          {"Paramètres du point " + currentdef.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AdvancedDefDialogPoint
            closeModal={handleEditClosepoint}
            def={currentdef}
            formulapretty={formulapretty}
            formulaprettyEdited={formulaprettyEdited}
            graphgranularity={'hour'}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditCloserealestate}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openrealestate}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloserealestate}>
          {"Paramètres de la valeur " + currentdef.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AdvancedDefDialogRealestate
            closeModal={handleEditCloserealestate}
            def={currentdef}
            formulapretty={formulapretty}
            formulaprettyEdited={formulaprettyEdited}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {redirecting}
    </ErrorBoundary>
  );
}
